<template>
    <app-dialog v-model="isOpen">
        <template #header>
            <span class="text-lg font-semibold text-theme-base">
                {{ title }}
            </span>
        </template>

        <div>
            <p v-if="intro" class="text-sm text-theme-muted mb-4">
                {{ intro }}
            </p>

            <div class="flex flex-col">
                <div
                    v-for="(step, index) in steps"
                    :key="index"
                    class="flex items-start mt-1"
                >
                    <div
                        class="w-6 h-6 flex-shrink-0 rounded-full bg-theme-primary text-theme-inverse flex items-center justify-center"
                    >
                        <span class="text-xs font-semibold">
                            {{ index + 1 }}
                        </span>
                    </div>
                    <span class="ml-2 text-sm text-theme-base leading-relaxed">
                        {{ step }}
                    </span>
                </div>
            </div>

            <div
                v-if="$slots.default"
                class="mt-4 pt-3 border-t border-theme-border text-sm text-theme-muted"
            >
                <slot />
            </div>
        </div>
    </app-dialog>
</template>

<script>
import AppDialog from "@/components/utils/AppDialog.vue";

export default {
    name: "ProcessGuide",
    components: { AppDialog },
    model: {
        prop: "value",
        event: "change"
    },
    props: {
        value: {
            type: Boolean,
            default: () => false,
            required: false
        },
        title: {
            type: String,
            default: () => "Guía del proceso",
            required: false
        },
        intro: {
            type: String,
            default: () => "",
            required: false
        },
        steps: {
            type: Array,
            default: () => [],
            required: true
        }
    },
    emits: ["change"],
    computed: {
        isOpen: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("change", value);
            }
        }
    }
};
</script>
